import React from "react";
import { Formik } from "formik";
import { Form } from "react-bootstrap";
import { SchoolProfileWizardNav } from "./SchoolProfileWizardNav";
import { SchoolInfoForm } from "./SchoolInfoForm";
import { ReceiptOfPaymentForm } from "./ReceiptOfPaymentForm";
import { DailyCourseHoursForm } from "./DailyCourseHoursForm";
import { DocumentInfoForm } from "./DocumentInfoForm";
import { MailAccountForm } from "./MailAccountForm";
import { SMSAccountForm } from "./SMSAccountForm";

export function SchoolProfileEditForm({ 
  schoolProfile,
  btnRef,
  saveSchoolProfile
}) {
  return (
    <Formik
      enableReinitialize={true}
      initialValues={schoolProfile}
      onSubmit={(values) => {
        const formData = new FormData();
        if (values.formationYear === "") values.formationYear = null;
        if (values.receiptOfPaymentOrderNo === "") values.receiptOfPaymentOrderNo = null;
        if (values.preRegistrationFomSerialNumber === "") values.preRegistrationFomSerialNumber = null;
        if (values.billNo === "") values.billNo = null;
        if (values.mailPortNumber === "") values.mailPortNumber = null;
        if (values.semesterCount === "") values.semesterCount = 0;
        if (values.dailyCourseHour === "") values.dailyCourseHour = 0;
        formData.append("fileData", values.logoFile);
        formData.append("fileRemove", document.getElementsByName("school_logo_remove")[0].value);
        formData.append("serializedData", JSON.stringify(values));
        saveSchoolProfile(formData);
      }}
    >
      {({ handleSubmit, handleChange, setFieldValue, values }) => (
        <Form onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
        }}>
          {/* <!--begin: Wizard --> */}
          <div
            className="wizard wizard-4"
            id="school_profile_form_wizard"
            data-wizard-state="step-first"
          >
            {/* <!--begin: Form Wizard Nav --> */}
            <SchoolProfileWizardNav />
            {/* <!--end: Form Wizard Nav --> */}

            <div className="pt-lg-5">
              {/* <!--begin: Form Wizard Form--> */}
              {/* <!--begin: Form Wizard Step 1--> */}
              <div data-wizard-type="step-content" data-wizard-state="current">
                <div className="mb-10"></div>
                <SchoolInfoForm
                  schoolProfile={schoolProfile}
                  handleChange={handleChange}
                  setFieldValue={setFieldValue}
                  values={values}
                />
              </div>
              {/* <!--end: Form Wizard Step 1--> */}

              {/* <!--begin: Form Wizard Step 2--> */}
              <div data-wizard-type="step-content">
                <div className="row">
                  <div className="col-6">
                    <h5 className="mb-10 font-weight-bold text-dark">
                      Tahsilat Makbuzu
                    </h5>
                    <ReceiptOfPaymentForm
                      handleChange={handleChange}
                      values={values}
                    />
                  </div>
                  
                  <div className="col-6">
                    <h5 className="mb-10 font-weight-bold text-dark">
                      Evrak Bilgileri
                    </h5>
                    <DocumentInfoForm
                      handleChange={handleChange}
                      values={values}
                    />
                  </div>
                </div>
              </div>
              {/* <!--end: Form Wizard Step 2--> */}

              {/* <!--begin: Form Wizard Step 3--> */}
              <div data-wizard-type="step-content">
                <div className="row">
                  <div className="col-6">
                    <h5 className="mb-10 font-weight-bold text-dark">
                      Mail Hesabı
                    </h5>
                    <MailAccountForm
                      handleChange={handleChange}
                      values={values}
                    />
                  </div>
                  
                  <div className="col-6">
                    <h5 className="mb-10 font-weight-bold text-dark">
                      SMS Hesabı
                    </h5>
                    <SMSAccountForm
                      handleChange={handleChange}
                      setFieldValue={setFieldValue}
                      values={values}
                    />
                  </div>
                </div>
              </div>
              {/* <!--end: Form Wizard Step 3--> */}       

              {/* <!--begin: Form Wizard Step 4--> */}      
              <div data-wizard-type="step-content">
                <DailyCourseHoursForm
                  handleChange={handleChange}
                  values={values}
                />     
              </div>
              {/* <!--end: Form Wizard Step 4--> */}
              {/* <!--end: Form Wizard Form--> */}
            </div>
          </div>          
          {/* <!--end: Wizard --> */}

          <button
            type="submit"
            style={{ display: "none" }}
            ref={btnRef}
          ></button>
        </Form>
      )}      
    </Formik>
  );
}